$(document).ready(function() {

    $('.js-gallery-slider').slick({
        dots: false,
        variableWidth: true,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: "unslick"
        //     }
        // ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/gallery.js